module.exports = __webpack_public_path__ + "img/coming.a036e3b0.png";